module.exports = __webpack_public_path__ + "static/media/paperclip-vector-6.5ef810e6.png";